import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useOrganization } from "../context/OrganizationContext";
import { AppBootSkeleton } from "./UI/DesignStandards";

const ProtectedRoute = ({ children, requireOrganization = false }) => {
  const { user } = useAuth();
  const { currentOrganization, loading } = useOrganization();
  const location = useLocation();

  if (loading) {
    return <AppBootSkeleton />;
  }

  // If not authenticated, redirect to sign in with current location
  if (!user) {
    return (
      <Navigate to="/signin" state={{ from: location.pathname }} replace />
    );
  }

  // If organization is required but user doesn't have one, redirect to organization page
  if (requireOrganization && !currentOrganization) {
    return <Navigate to="/organization" replace />;
  }

  return children;
};

export default ProtectedRoute;
